import React from 'react';
import { styled } from '@this/constants/themes';

import Tooltip from '@this/shared/tooltip/tooltip';
import { reportError } from '@this/lib/bugsnag';
import type Transit from '../../../../domain/transit/transit2';

import TranslateIgnoreText from '../../../shared/text/translate_ignore_text';

type Props = {
  transit?: Transit;
  domesticAirPriceIndex: number | null | undefined;
};

const ReserveConfirmTransitTr: React.FC<Props> = ({ transit, domesticAirPriceIndex }) => {
  try {
    const shinkansenTooLate = false;

    return transit ? (
      transit.shinkansen && shinkansenTooLate ? (
        <ShinkansenTooLate>
          新幹線のチケットは郵送する必要がありますので出発の2日前以降のご予約は承っておりません。
        </ShinkansenTooLate>
      ) : (
        <>
          <TranslateIgnoreText
            text={transit.legsummariesFromtoJrair ? transit.legsummariesFromtoJrair : transit.legsFromto}
          />
          <TextDetail>
            {transit.air === true ? (
              <>
                <TranslateIgnoreText text={transit.selectedText} />
                {transit.prices && domesticAirPriceIndex != null && (
                  <TicketSeatTypeArea>{`券種: ${
                    transit.prices[domesticAirPriceIndex].ticketCategory === 'changeable' ? '変更可' : '変更不可'
                  } 席種: ${transit.prices[domesticAirPriceIndex].seatType}`}</TicketSeatTypeArea>
                )}
              </>
            ) : (
              <TranslateIgnoreText text={transit.selectedText} />
            )}
          </TextDetail>
          <TextDetail>
            {transit.parentItem?.railwayDistance && transit.shinkansen && !transit.package && (
              <TextKm>
                営業キロ
                <Tooltip width={300}>
                  <TextKmDetail>
                    ※営業キロとは、鉄道における営業線の長さを示すキロ程のことであり、運賃計算などの基礎となる数字です。
                  </TextKmDetail>
                  <TextKmDetail>※営業キロは新幹線だけでなく在来線も含みます。</TextKmDetail>
                </Tooltip>
                ：<span data-wovn-ignore>{transit.parentItem.railwayDistance}</span>km
              </TextKm>
            )}
          </TextDetail>
          {!transit.package && (
            <>
              {transit.priceDetailArray.map((d, i) => (
                <PriceDetail key={i}>
                  <p>{d.title}</p>
                  <p>{d.price}</p>
                </PriceDetail>
              ))}
            </>
          )}
        </>
      )
    ) : (
      <span>-</span>
    );
  } catch (e) {
    reportError(e);
    return null;
  }
};

const ShinkansenTooLate = styled.span`
  color: ${props => props.theme.redColor};
`;

const TicketSeatTypeArea = styled.div`
  margin-bottom: 10px;
`;

const PriceDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 100px;
`;

const TextDetail = styled.div`
  font-size: 0.9em;
  padding-left: 0.9em;
  font-weight: normal;
`;

const TextKm = styled.div`
  display: flex;
`;

const TextKmDetail = styled.p`
  padding-left: 1em;
  text-indent: -1em;
`;

export default ReserveConfirmTransitTr;
